import { useEffect } from 'react';
import { InteractionType } from '@azure/msal-browser';
import { useLocation, useNavigate } from 'react-router';
import { useIsAuthenticated, MsalAuthenticationTemplate } from '@azure/msal-react';

import { SplashScreen } from 'src/components/loading-screen';

import { useAuthContext } from '../hooks/useAuthContext';

type Props = {
  children: React.ReactNode;
};

function AuthGuard({ children }: Props) {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  const navigate = useNavigate();
  const { isLoading } = useAuthContext();

  useEffect(() => {
    /*
      Remove query parameters manually when redirect url is not being handled properly by Azure AD SSO
      This usually happen when idToken expires earlier than expected. Then the user is redirected to the login page
    */
    if (isAuthenticated) {
      const urlParams = new URLSearchParams(location.hash);
      let shouldUpdate = false;

      ['code', 'state', 'session_state'].forEach((param) => {
        if (urlParams.has(param)) {
          urlParams.delete(param);
          shouldUpdate = true;
        }
      });

      if (shouldUpdate) {
        navigate(location.pathname, { replace: true });
      }
    }
  }, [isAuthenticated, location, navigate]);

  return (
    <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
      {isLoading ? <SplashScreen /> : children}
    </MsalAuthenticationTemplate>
  );
}

export default AuthGuard;
